
export default {
    methods:{
        getStyleVisibleFalseInContent(visible){
            if (visible){
                return ''
            }else{
                // return  `background: #f7f7f8; margin: 0;padding: 0;  text-decoration: line-through;color: #8d9aa8;!important;`
                return  `background: #f7f7f8; margin: 0;padding: 0;color: #8d9aa8;!important;`
            }
        }
    },
}